import { httpCreate, errors } from './http';
import { activity } from './activity';

import conf from '@/config';

const baseURL = conf.uploadHost;

const http = httpCreate(conf.apipath + '/upload');
const shopHttp = httpCreate(conf.surveyApipath + '/upload');

const getUrlPath = (path) => {
	return `${conf.Host}${path}`;
}
async function getToken(uploadType, businessType, mid, photoLive = 0) {
	try {
		let token = sessionStorage.getItem(`${uploadType}${businessType}${mid}`);
		token = token && JSON.parse(token);
		// 如果sessionStorage中没有token或者token过期则请求token
		if (!token || token.expire * 1e3 <= +new Date()) {
			const { ok, data } = await activity.getToken(mid, { uploadType, businessType, photoLive });
			if (ok) {
				sessionStorage.setItem(`${uploadType}${businessType}${mid}`, JSON.stringify(data.data.token));
				return data.data.token;
			}
		} else {
			return token;
		}
	} catch (error) {
		errors(error);
	}
}
export const upload = {
	getToken(storeId, type) {
		return shopHttp.get('/token', {
			params: {
				storeId: storeId ? storeId : 0,
				uploadType: type ? type : 'image',
			},
		});
	},
	async uploadFile(storeId, file, type, config) {
		const { data, ok } = await upload.getToken(storeId ? storeId : 0, type ? type : 'image');
		if (!ok) {
			return;
		}
		const backend = encodeURIComponent(
			`${process.env.NODE_ENV == 'development' ? 'https://beta.tuwenzhibo.com' : conf.host}${conf.surveyApipath}${
				conf.uploadsever
			}`
		);
		return http.post(`/upload/file/image?backend=${backend}`, file, {
			...config,
			baseURL,
			headers: {
				token: data.data.token,
			},
		});
	},
	async file(data, type, backendParams, config) {
		const token = await getToken(type, 'recruit', 0);
		const backend = encodeURI(getUrlPath('/srv/api/fileStorage/one', backendParams));
		return http.post(`/file/${type}?backend=${backend}`, data, {
			...config,
			baseURL: baseURL + '/upload',
			headers: {
				token: token,
			},
		});
	},
};
